import { render, staticRenderFns } from "./goodsManageRouter.vue?vue&type=template&id=b4f9d0f8&"
import script from "./goodsManageRouter.vue?vue&type=script&lang=js&"
export * from "./goodsManageRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports